<template>
  <v-layout row class="range-slider-input">
    <div v-if="isNormalized" class="flex h-14 grow">
      <v-range-slider
        v-model="values"
        hideDetails
        :max="max"
        :min="min"
        :step="step"
        :disabled="disabled"
        showTicks="always"
        :ticks="ticks"
        tickSize="2"
        @update:modelValue="valueChanged"
      ></v-range-slider>
    </div>
    <div v-else class="flex grow">
      <div class="range-slider rf-range-slider flex grow">
        <v-text-field
          v-model="leftSlider"
          persistentPlaceholder
          class="slider-input sinput-left mt-0"
          pattern="([0-9]+|Any)"
          hideDetails
          singleLine
          :disabled="disabled"
        />
        <v-text-field
          v-model="rightSlider"
          persistentPlaceholder
          class="slider-input sinput-right mt-0"
          pattern="([0-9]+|Any)"
          hideDetails
          singleLine
          :disabled="disabled"
        />
        <v-range-slider
          v-model="formattedValue"
          hideDetails
          class="pb-2"
          :max="max"
          :min="min"
          :step="step"
          :disabled="disabled"
          @update:modelValue="valueChanged"
        ></v-range-slider>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: "RfRangeSlider",
  props: ["min", "max", "step", "disabled", "modelValue", "isNormalized"],
  data() {
    return {
      values: this.modelValue,
    };
  },
  computed: {
    ticks() {
      const step = this.step || 1;
      const length = Math.floor(this.max - this.min) / step + 1;
      return Array.from({ length }, (_, i) => this.min + i * step);
    },
    formattedValue: {
      get() {
        if (
          this.values &&
          !Number.isNaN(this.values[0]) &&
          !Number.isNaN(this.values[1]) &&
          this.values.length === 2
        ) {
          return [this.values[0], this.values[1]];
        }
        return [this.min, this.max];
      },
      set(value) {
        const [left, right] = value;
        const leftNum = parseInt(left);
        const rightNum = parseInt(right);
        this.values = [leftNum, rightNum];
      },
    },
    leftSlider: {
      get() {
        if (this.formattedValue[0] === this.min) {
          return "Any";
        }
        return this.formattedValue[0];
      },
      set(value) {
        const index = 0;
        const parsedVal = parseInt(value);
        const isNan = Number.isNaN(parsedVal);
        if (isNan && value !== "Any") {
          return;
        }
        if (parsedVal < this.min) {
          return;
        }

        const values = this.formattedValue.slice();
        if (value === "Any" || parsedVal < this.min) {
          values[index] = this.min;
        } else if (parsedVal >= this.max) {
          values[index] = this.max;
        } else {
          values[index] = parsedVal;
        }

        this.formattedValue = values;
        this.modelValue[index] = values[index];
      },
    },
    rightSlider: {
      get() {
        if (this.formattedValue[1] === this.max) {
          return "Any";
        }
        return this.formattedValue[1];
      },
      set(value) {
        const index = 1;
        const parsedVal = parseInt(value);
        const isNan = Number.isNaN(parsedVal);
        if (isNan && value !== "Any") {
          return;
        }

        if (parsedVal > this.max) {
          return;
        }

        const values = this.formattedValue.slice();
        if (value === "Any" || parsedVal >= this.max) {
          values[index] = this.max;
        } else if (parsedVal <= this.min) {
          values[index] = this.min;
        } else {
          values[index] = parsedVal;
        }

        this.formattedValue = values;
        this.value[index] = values[index];
      },
    },
  },
  watch: {
    modelValue(v) {
      this.values = v;
    },
  },
  methods: {
    valueChanged(to) {
      this.$emit("update:modelValue", to);
    },
  },
};
</script>
<style lang="scss">
.range-slider-input {
  padding: 0 1rem;
}
.v-text-field.slider-input {
  width: 36px;
  display: flex;
  position: absolute;

  padding-top: 0px;

  &.v-text-field {
    input {
      padding: 4px 0;
      font-size: 14px;
    }
  }

  &.sinput-right.v-text-field input {
    text-align: right;
  }
}

.sinput-left {
  left: 0;
  top: 0;
  pointer-events: none;
}

.sinput-right {
  right: 0;
  top: 0;
  pointer-events: none;
}
.range-slider {
  position: relative;
  padding-top: 16px;
}

.rf-range-slider {
  .v-text-field > .v-input__control > .v-input__slot:before,
  .v-text-field > .v-input__control > .v-input__slot:after {
    width: 0px;
  }
  .v-input--range-slider {
    margin-top: 12px;
  }
}
</style>
